import { AxiosResponse } from "axios";
import { useInfiniteQuery } from "react-query";

import { TGetAllStoreProducts } from "core/models/store-products.model";
import { MainUrl } from "core/data/main-url";
import { IAxiosResult } from "../../models/axios-result.model";
import methods from "../interceptors/http.interceptor";

const GetAllStoreProducts = async (
  params: TGetAllStoreProducts,
): Promise<AxiosResponse<IAxiosResult>> => {
  const { productType, ...rest } = params;
  return await methods.post(
    `${MainUrl}/api/store/Product/GetAllProducts/${productType}`,
    rest,
  );
};

export const useGetAllStoreProducts = (
  params: Omit<TGetAllStoreProducts, "page">,
) => {
  return useInfiniteQuery(
    ["GetAllStoreProducts", params],
    ({ pageParam = 1 }) =>
      GetAllStoreProducts({
        ...params,
        page: pageParam,
      }),
    {
      getNextPageParam: (lastPage) => {
        const { currentPage, totalCount } = lastPage.data?.result;
        const itemsFetched = currentPage * params.pageSize;
        return itemsFetched < totalCount ? currentPage + 1 : undefined;
      },
      staleTime: 2 * 60 * 1000,
      cacheTime: 2 * 60 * 1000,
      keepPreviousData: true,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      enabled: params.pageSize > 0,
    },
  );
};
